import {css, CSSWideKeyword, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as Colors from 'ui-library/Colors';
import PlaceholderText from 'ui-library/PlaceholderText';

import {Optional} from '../util/Types';

interface Props {
  value: Optional<string | number>;
  placeholder?: string | null;
  isFaded?: boolean;
  breakLines?: boolean;
}

/**
 * Renders a text value or placeholder if it is empty.
 */
export default function TextValue({value, placeholder, isFaded, breakLines}: Props): JSX.Element {
  return value != null && value !== '' ? (
    <span
      className={classNames({
        [css(styles.breakAnywhere)]: breakLines,
        [css(styles.ellipsisText)]: !breakLines,
        [css(styles.faded)]: isFaded,
      })}
    >
      {value}
    </span>
  ) : (
    <PlaceholderText value={placeholder} />
  );
}

const styles = StyleSheet.create({
  breakAnywhere: {
    overflowWrap: 'break-word',
    lineBreak: 'anywhere' as CSSWideKeyword, // Aphrodite does not recognize anywhere even though it is a valid value
  },
  ellipsisText: {
    display: 'block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  faded: {
    color: Colors.GRAY_DARK,
  },
});
